import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";

type Props = {
	title: string;
	actionLabel?: string;
	onAction?: () => void;
};

export const DashboardSectionHeader: FC<Props> = ({
	title,
	actionLabel,
	onAction,
}) => {
	const theme = useTheme();

	return (
		<Stack
			direction="row"
			alignItems="center"
			justifyContent="space-between"
			px={1.6}
			py={1}
		>
			<Typography variant="overline" color="text.secondary">
				{title}
			</Typography>
			{actionLabel && onAction && (
				<Typography
					component="button"
					variant="button"
					onClick={onAction}
					color={theme.palette.blue[600]}
					border="none"
					p={0}
					sx={{ background: "transparent", cursor: "pointer" }}
				>
					{actionLabel}
				</Typography>
			)}
		</Stack>
	);
};
